var map = {
	"./Community-White.png": 7355,
	"./DataDisclosure-White.png": 630,
	"./Environment-White.png": 7356,
	"./Governance-White.png": 7357,
	"./Marketplace-White.png": 7358,
	"./Purpose-White.png": 7359,
	"./StructureDirectors-White.png": 629,
	"./Workplace-White.png": 7360
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 495;